import gql from "graphql-tag";

export const surveyQuery = gql`
  query survey($surveyId: ID!) {
    survey(id: $surveyId) {
      id
      title
      text
      url
      startsAt
      endsAt
      maxShows
    }
  }
`;
